import './Prediction.scss';
import React, { useState } from "react";
import WeatherConditions from '../../WeatherConditions';
import calendar from '../../../assets/icons/calendar-icon.png';
import location from '../../../assets/icons/location-icon.png';
import globe from '../../../assets/icons/globe-icon.png';
import moment from 'moment-timezone';
import { useUserContext } from '../../../contexts/UserContext';
import { useSensorDataContext } from '../../../contexts/SensorDataContext';

export default function Prediction(props) {
    const {
        is3D,
        setIs3D
    } = useUserContext();

    const {
        layers,
        setLayers
    } = useSensorDataContext();

    const { 
        setPanel, 
        map, 
        prediction
    } = props;

    console.log('prediction', prediction);

    const goToPrediction = () => {
        setPanel({
            name: 'Prediction PopUp',
            content: prediction
        })

        const selected = map.current.getStyle().layers.filter((l) => l?.id?.includes('Layer-Prediction-symbol'))[0];
                        
        map.current.setLayoutProperty(selected?.id, 'visibility', 'visible');

        setLayers({
            ...layers,
            predictions: true
        });


        const location = [prediction.longitude, prediction.latitude]
        map.current.flyTo({center: location, zoom: 11, pitch: 0, offset: [250, 0]});

        if (is3D) {
            setIs3D(false);
        }
    }

    const formatDate = (timestamp) => {
        const time = moment.utc(timestamp).local();
        return time.format('YYYY-MM-DD hh:mm:ss A');
    }

    return (
        <div className='prediction-card'>
            <div className="prediction-card-main">
                <div className="prediction-card-main-id">ID: {prediction.fire_id}</div>
                <div className="prediction-card-main-country">
                    <img src={globe} className="prediction-card-main-country-icon" alt="Country" />
                    <div className="prediction-card-main-country-value">
                        {prediction.country || 'Not Available'}
                    </div>
                </div>
                <div className="prediction-card-main-date">
                        <img src={calendar} className="prediction-card-main-date-icon" alt="Calendar" />
                        <div className="prediction-card-main-date-value">
                            {prediction.event_date
                                ? formatDate(prediction.event_date)
                                : prediction.starttimestamp
                                ? formatDate(prediction.starttimestamp)
                                : 'Not Available'
                            }
                        </div>
                </div>
                <div className="prediction-card-main-location">
                    <img src={location} className="prediction-card-main-location-icon" alt="Location" />
                    <div className="prediction-card-main-location-value">
                        {`${prediction.latitude.toFixed(5)}, ${prediction.longitude.toFixed(5)}`}
                    </div>
                </div>
                {/* <WeatherConditions coordinates={[prediction.latitude, prediction.longitude]}/> */}
            </div>
            <div className="prediction-card-btns">
                <div 
                    className="prediction-card-btns-btn-view"
                    onClick={goToPrediction}    
                    >
                    View
                </div>
            </div>
        </div>
    );
}